// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"P5-z","displaySixCardTiles":"Q5-z"};